<template>
  <div>
    <request-detail-card
      v-for="(request, r) in items"
      :key="`${request.id}${r}`"
      :medical-record-id="id"
      :request="request"
      kind="hospitalization"
      :can-sign="canSign"
    />
  </div>
</template>

<script>
import RequestDetailCard from './RequestDetailCard.vue';

export default {
  components: {
    RequestDetailCard,
  },
  props: {
    id: {
      type: String,
    },
    items: {
      type: Array,
    },
    canSign: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
  @import "./src/assets/scss/_variables.scss";
</style>
